
import * as React from "react";
import * as ReactDOM from "react-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery';
import 'bootstrap';
import { Url } from "../avernus/url/source/Url";
import { Api } from "./lib/Api";
import Login from "./components/auth/login/Login";
import Dashboard from "./components/admin/Dashboard";
import UserList from "./components/service/user/UserList";
import RestaurantList from "./components/service/restaurant/RestaurantList";
import UserIndex from "./components/user/UserIndex";
import RestaurantProfile from "./components/service/RestaurantProfile";
import ServiceMenu from "./components/service/ServiceMenu";
import RestaurantOpeningHours from "./components/service/RestaurantOpeningHours";
import OfferList from "./components/service/offer/OfferList";
import UserRestaurantList from "./components/user/UserRestaurantList";
import { Order } from "./components/user/Order";
import PrivacyPolicy from "./components/user/PrivacyPolicy";
import Profile from "./components/user/Profile";
import OrderList from "./components/service/order/OrderList";
import { Std } from "../avernus/std/Std";
import { Lng } from "../languages/Languages";
import ShowOrder from "./components/user/ShowOrder";
import Review from "./components/service/order/Review";
import UserReview from "./components/user/order/UserReview";

interface IAppMainProps {
}

interface IAppMainState {
    currentUrl: string
    data      : any
}

interface ICheckTokenFunction{
    (redirectUrl:string):void
}

export interface ISetUrl{
    (url:string, data?:any):void
}
declare var FCMPlugin:any;

export default class AppMain extends React.Component<IAppMainProps, IAppMainState>{

    private firstUrl:string;
    private mounted:boolean;

    constructor(props:IAppMainProps){
        super(props);
        this.mounted = false;
        this.state = {
            currentUrl: '',
            data: null
        };
        this.firstUrl = ('/'+Url.getUrl())==='/'?'/index':('/'+Url.getUrl());
        //if ( this.firstUrl === '/login' ) {
        if ( this.firstUrl === '/index' ) {
            this.firstUrl = this.getFirstUrl();
        }
        this.checkToken();
        (window as any).redirectToLogin = () =>{
            this.redirectToLogin();
        }
        // this.getPushNoticeToken();

    }

    private getFirstUrl(url:string='index'):string{
     //   let restaurants = Api.getRestaurants();
        let permission  = Api.getPermission();
        if ( url === undefined ) {
            url = 'index';
        }
        if ( permission !== undefined) {
            if ( permission.indexOf('admin') > -1 ) {
                if ( (url === 'index' || url === 'admin' ) && this.firstUrl.indexOf('/admin/') === 0 ) {
                    return this.firstUrl;
                }
                return '/admin/'+url;
            }

            if ( permission.indexOf('manager') > -1 ) {
                if ( (url === 'index' ) && this.firstUrl.indexOf('/restaurant/') === 0 ) {
                    return this.firstUrl;
                }
                return '/restaurant/'+url;
            }


        }

        if ( url === 'index' &&  this.firstUrl.indexOf('/user/') === 0 ) {
            return this.firstUrl;
        }
        return '/login';
    }

    private redirectToLogin():void{
        this.setUrl('/login');
    }

    checkToken(cb:ICheckTokenFunction=null, redirectUrl?:string):void {
        Api.check((valid)=>{
            if ( valid ) {
                if ( cb !== null) {
                    cb(redirectUrl);
                }else{
                    this.setUrl(this.firstUrl);
                }
            }else{
                // let redirectUrl = '/login';
                Api.cleanStorage();
                console.log('order cleared!');
                let redirectUrl = this.getFirstUrl('index');
                if ( cb !== null) {
                    cb(redirectUrl);
                }else{
                    this.setUrl(redirectUrl);
                }

            }
        });
    }

    private getPlaceClass(){
        if ( Url.isUrl(/^restaurant\//) ) {
            return 'service';
        }
        if ( Url.isUrl(/^admin\//) ) {
            return 'admin';
        }
        return 'user';
    }

    private addSafariTag(){
        if ( Url.isSafari() ) {
            return 'safari_browser'
        } else {
            return Std.cleanStr(device.platform)+'_device';
        }
    }

    render() {
        (document.body as any).classList = ['bg '+ this.getPlaceClass() + ' ' + this.addSafariTag()];
        setTimeout(() => {
            this.mounted = true;
        }, 100);
        let permission = Api.getPermission();
        if ( Url.isUrl(/index.html/) ) {
            // this.setUrl('/login');
            this.redirectToHomePage();
        }
        if ( Url.isUrl(/admin$/) ) {
            this.setUrl('/admin/');
        }
        if ( Url.isUrl(/undefined$/) ) {
            this.redirectToHomePage();
        }
        if ( Url.isUrl(/^index$/) ) {
            this.redirectToHomePage();
        }
        if ( Url.isUrl(/^menu$/) ) {
            this.redirectToMenuPage();
        }
        if ( Url.isUrl(/^user$/) || Url.isUrl(/^restaurant$/) || Url.isUrl(/^admin$/)  ) {
            this.redirectToMenuPage();
        }
        let restaurantId:number = null;
        if ( Api.getCurrentRestaurant() !== null ) {
            restaurantId = Api.getCurrentRestaurant().id;
        }
        setTimeout(() => {
            //position hamuberg menu tirigger button
            if ( document.getElementById('trigger_btn') === null ) {

                let hemburger_menu = document.querySelector('.hemburger_menu');
                if ( hemburger_menu !== null ) {
                    let trigger_btn = document.createElement('a');
                    trigger_btn.id='trigger_btn';
                    var rect = hemburger_menu.getBoundingClientRect();
                    trigger_btn.style.top = rect.top+'px';
                    trigger_btn.style.left= rect.left+'px';
                    trigger_btn.addEventListener('click', (e)=>{
                        e.preventDefault();
                        (document.querySelector('.hemburger_menu') as HTMLLinkElement).click();
                    });
                    document.body.appendChild(trigger_btn);
                }
            }
            if ( Url.isUrl(/\/index/)) {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }, 200);

        return (
            <>
               {/*{ Config.isTestVersion()===true?<h1 style={{
                    position: 'absolute',
                    textAlign:'center',
                    background: 'yellow',
                    fontSize: '18px',
                    padding: '5px',
                    zIndex: 99999,
                    top: 0
                }}>TEST VERSION</h1>:''}*/}

                { ( Url.isUrl(/admin\/$/) || Url.isUrl(/admin\/index/) || Url.isUrl(/admin\/menu/) ) && permission.indexOf('admin')>-1?
                    <Dashboard setUrl={
                        (url) =>{
                            this.setUrl(url);
                        }
                    } />:'' }

                { Url.isUrl(/admin\/users/) && permission.indexOf('admin')>-1?
                    <UserList urlPrefix="/admin" setUrl={
                        (url) =>{
                            this.setUrl(url);
                        }
                    } />:'' }
                { Url.isUrl(/admin\/restaurants/) && permission.indexOf('admin')>-1?
                    <RestaurantList urlPrefix="/admin" setUrl={
                        (url) =>{
                            this.setUrl(url);
                        }
                    } />:'' }

                { Url.isUrl(/user\/index/)?<UserIndex setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    } />:'' }

                { Url.isUrl(/user\/menu/)?<UserIndex setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    } />:'' }

                { Url.isUrl(/user\/offers/)?<UserRestaurantList setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                    filter={ (this.state.data!==null && this.state.data.filter!=undefined)?this.state.data.filter:'' }
                    openedId={ (this.state.data!==null && this.state.data.restaurantId!=undefined)?parseInt(this.state.data.restaurantId):null}
                    title={Lng.get('offers_near_you')}
                    view={"with_image"}
                    sortingMethod={"nearYou"}
                    isOpenToday={true}
                    shortByEnabled={true}
                    viewForViewRestaurant="showRestaurant"
                />:'' }

                { Url.isUrl(/user\/favourite-restaurants/)?<UserRestaurantList setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                    title={Lng.get('favourite_restaurants')}
                    view={"with_image"}
                    sortingMethod={"nearYou"}
                    headerImg="img/headers/favourite_restaurants.png"
                    justLiked={true}
                    shortByEnabled={true}
                    viewForViewRestaurant="showRestaurant"
                />:'' }

                { Url.isUrl(/user\/map-search/)?<UserRestaurantList setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                    title={Lng.get('map_search')}
                    view={"googlemap"}
                    sortingMethod={"nearYouAll"}
                    viewForViewRestaurant="showRestaurant"
                />:'' }

                { Url.isUrl(/user\/submit-order/)?<UserRestaurantList setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                    title=""
                    view={"with_image"}
                    sortingMethod={"nearYou"}
                    shortByEnabled={true}
                    viewForViewRestaurant='submitOrder'
                    openedId={Order.getRestaurantId()}
                />:'' }


                { Url.isUrl(/user\/privacy-policy/)?<PrivacyPolicy setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                />:'' }


                { Url.isUrl(/user\/profile/)?<Profile setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                />:'' }

                { Url.isUrl(/user\/restaurants-you-ordered-from/)?<UserRestaurantList setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                    title={Lng.get('restaurants_you_ordered_from')}
                    view={"ordered_with_image"}
                    sortingMethod={"nearYou"}
                    headerImg="img/headers/app_order.png"
                    justOrdered={true}
                    shortByEnabled={true}
                    viewForViewRestaurant="showRestaurant"
                />:'' }





                { Url.isUrl(/restaurant\/index/)?<ServiceMenu setUrl={
                    (url, data) =>{
                        this.setUrl(url, data);
                    }
                } />:'' }


                { Url.isUrl(/restaurant\/active-orders/)?<OrderList
                    title="Active orders"
                    restaurantId={restaurantId}
                    showJustActiveOrders={true}
                    setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                } />:'' }
                { Url.isUrl(/restaurant\/orders/)?<OrderList
                    title="Orders summary"
                    restaurantId={restaurantId}
                    setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                } />:'' }

                { Url.isUrl(/restaurant\/menu/)?<ServiceMenu setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    } />:'' }
                { Url.isUrl(/restaurant\/profile/)?<RestaurantProfile
                        createNew={ (this.state.data!==null && this.state.data.createNew!=undefined)?this.state.data.createNew:false }
                        setUrl={
                            (url, data) =>{
                                this.setUrl(url, data);
                            }
                        }
                    />:'' }
                { Url.isUrl(/restaurant\/users/)?<UserList
                        urlPrefix=""
                        restaurantId={restaurantId}
                        setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    } />:'' }
                { Url.isUrl(/restaurant\/opening-hours/)?<RestaurantOpeningHours
                        id={restaurantId}
                        setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    } />:'' }
                { Url.isUrl(/restaurant\/offers/)?<OfferList
                        restaurantId={restaurantId}
                        setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    } />:'' }
                { Url.isUrl(/restaurant\/active-offers/)?<OfferList
                        activeOfferMode={true}
                        restaurantId={restaurantId}
                        setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    } />:'' }

                { Url.isUrl(/login/)?
                    <Login setUrl={
                        (url:string) =>{
                            if ( url !== null) {
                                this.setUrl(url);
                            }else{
                                this.redirectToHomePage();
                            }
                        }
                    } />:'' }

                { Url.isUrl(/user\/order/) &&
                    <ShowOrder setUrl={
                            (url, data) =>{
                                this.setUrl(url, data);
                            }
                        }
                        order = {this.state.data.order}
                    />
                }

                { Url.isUrl(/restaurant\/order\/review/) &&
                    <Review setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                               order = {this.state.data.order}
                    />
                }

                { Url.isUrl(/user\/order\/review/) &&
                    <UserReview setUrl={
                        (url, data) =>{
                            this.setUrl(url, data);
                        }
                    }
                            order = {this.state.data.order}
                    />
                }



            </>
        );
    }

    private redirectToHomePage():void{
        let permission = Api.getPermission();
        if ( permission.indexOf('admin') > -1 && this.firstUrl.indexOf('admin') === -1) {
            // when admin but not admin url
            this.firstUrl = '/admin';
        }else  if ( permission.indexOf('admin') == -1 && this.firstUrl.indexOf('admin') > -1 ) {
            // when user, but admin url
            this.firstUrl = this.getFirstUrl();
        }else{
            this.firstUrl = this.getFirstUrl();
        }
        this.setUrl(this.firstUrl);
    }

    private redirectToMenuPage():void{
        this.setUrl(this.getFirstUrl('menu'));
    }

    setUrl(url:string, data:any=null) {
        const element = document.getElementById('app');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }

        if (
            Api.isEnabledNavigateToProfilPage() === true
            && url !== '/login'
            // && url !== '/user/term-and-conditions'
            && url !== '/user/privacy-policy'
            ) {
            console.log('Blocked: '+ url);
            url ='/user/profile';
        }
        if ( url.indexOf('/undefined') > -1) {
            url = url.replace('/undefined','/index');
        }
        console.log(this.state.currentUrl, url, Url.getUrl());
        if ( this.state.currentUrl !== url || this.state.currentUrl !== Url.getUrl() ) {
            // this.checkToken((redirectUrl)=>{
                url = Url.setUrl(url);
                if ( this.mounted === true ) {
                    this.setState({
                        currentUrl: url,
                        data: data
                    });
                }else{
                    setTimeout(() => {
                        this.setState({
                            currentUrl: url,
                            data: data
                        });
                    }, 200);
                }


            // }, url);
        }
    }
}
export class InitAppMain {
    constructor() {
        try {
            StatusBar.styleDefault()
        } catch (error) { }
        var div: HTMLDivElement = document.getElementById('app') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.unmountComponentAtNode(div);
            ReactDOM.render(<AppMain />, div);
        }
    }
}
